import React from 'react';
import AImagePicker from 'antd-mobile/lib/image-picker';



export default class ImagePicker extends AImagePicker {}